module.exports = __webpack_public_path__ + "static/media/onco_program.6b670659.png";